import type { DynamicForm, QuestionnaireDynamicFormField } from '@/types/questionnaire';

export const getDynamicFormFields = (fields: QuestionnaireDynamicFormField[]) => {
	const formFieldObject: DynamicForm = {};

	fields.forEach((field) => {
		formFieldObject[field.fieldName] = '';
	});

	return formFieldObject;
};